// extracted by mini-css-extract-plugin
export default {"richText":"RichText_richText__YrPMD","mangfoldsprisLayout":"RichText_mangfoldsprisLayout__DNywN"};